import React, { useState, Component } from 'react';
import { MailIcon, PhoneIcon, MessageSquareIcon, CheckCircleIcon } from 'lucide-react';
export const ContactSection = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    organization: '',
    message: '',
    submitted: false
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`gTLD Inquiry from ${formState.name} - ${formState.organization}`);
    const body = encodeURIComponent(`Name: ${formState.name}\nEmail: ${formState.email}\nOrganization: ${formState.organization}\n\nMessage:\n${formState.message}`);
    window.location.href = `mailto:newgtlds@gtlaw.com?subject=${subject}&body=${body}`;
    setTimeout(() => {
      setFormState(prev => ({
        ...prev,
        submitted: true
      }));
    }, 500);
  };
  return <section id="contact" className="py-24 bg-[#FAF9F5]" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-48">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-[#C4A44A] mx-auto mb-6" data-id="element-49"></div>
          <p className="text-xl text-[#5A5535] max-w-3xl mx-auto font-light" data-id="element-50">
            Ready to prepare for the 2026 gTLD application round? Our team is
            here to help guide you through the process.
          </p>
        </div>

        <div className="bg-white rounded-sm overflow-hidden shadow-xl border border-[#EDE9DB]" data-id="element-51">
          <div className="md:flex" data-id="element-52">
            <div className="md:w-2/5 bg-[#1E1D14] p-10 md:p-14 text-white relative" data-id="element-53">
              <div className="absolute top-0 left-0 w-full h-2 bg-[#C4A44A]" data-id="element-54"></div>
              <h3 className="text-2xl font-bold mb-8 font-serif text-white" data-id="element-55">
                Get in Touch
              </h3>
              <p className="mb-10 text-white font-light leading-relaxed" data-id="element-56">
                Have questions about the 2026 gTLD application process? Our team
                is ready to assist you with preparation and strategy.
              </p>
              <div className="space-y-8" data-id="element-57">
                <div className="flex items-start" data-id="element-58">
                  <div className="flex-shrink-0 mt-1 bg-[#3D3A25] p-2 rounded-full" data-id="element-59">
                    <MailIcon className="h-5 w-5 text-[#C4A44A]" data-id="element-60" />
                  </div>
                  <div className="ml-4" data-id="element-61">
                    <p className="text-white font-semibold" data-id="element-62">
                      newgtlds@gtlaw.com
                    </p>
                    <p className="text-sm text-white mt-1" data-id="element-63">
                      Email us for general inquiries
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-64">
                  <div className="flex-shrink-0 mt-1 bg-[#3D3A25] p-2 rounded-full" data-id="element-65">
                    <PhoneIcon className="h-5 w-5 text-[#C4A44A]" data-id="element-66" />
                  </div>
                  <div className="ml-4" data-id="element-67">
                    <p className="text-white font-semibold" data-id="element-68">
                      +1 (970) 300-5313
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:w-3/5 bg-white p-10 md:p-14" data-id="element-69">
              {formState.submitted ? <div className="h-full flex flex-col items-center justify-center text-center" data-id="element-70">
                  <div className="bg-[#F7F5EE] p-6 rounded-full mb-8 border border-[#D4C88A]" data-id="element-71">
                    <CheckCircleIcon className="h-16 w-16 text-[#5A5535]" data-id="element-72" />
                  </div>
                  <h3 className="text-3xl font-bold text-[#1E1D14] mb-4 font-serif" data-id="element-73">
                    Thank You!
                  </h3>
                  <p className="text-[#3D3A25] mb-8 text-lg" data-id="element-74">
                    We've received your message and will get back to you as soon
                    as possible.
                  </p>
                  <button onClick={() => setFormState(prev => ({
                ...prev,
                submitted: false,
                name: '',
                email: '',
                organization: '',
                message: ''
              }))} className="text-[#C4A44A] font-bold uppercase tracking-wide hover:text-[#5A5535] transition-colors border-b-2 border-transparent hover:border-[#5A5535] pb-1" data-id="element-75">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-76">
                  <div data-id="element-77">
                    <label htmlFor="name" className="block text-sm font-bold text-[#1E1D14] mb-2 uppercase tracking-wide" data-id="element-78">
                      Full Name
                    </label>
                    <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} required className="w-full px-4 py-3 border border-[#D4C88A] rounded-sm focus:ring-2 focus:ring-[#C4A44A] focus:border-[#C4A44A] bg-[#FAF9F5]" placeholder="John Doe" data-id="element-79" />
                  </div>
                  <div data-id="element-80">
                    <label htmlFor="email" className="block text-sm font-bold text-[#1E1D14] mb-2 uppercase tracking-wide" data-id="element-81">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required className="w-full px-4 py-3 border border-[#D4C88A] rounded-sm focus:ring-2 focus:ring-[#C4A44A] focus:border-[#C4A44A] bg-[#FAF9F5]" placeholder="john@example.com" data-id="element-82" />
                  </div>
                  <div data-id="element-83">
                    <label htmlFor="organization" className="block text-sm font-bold text-[#1E1D14] mb-2 uppercase tracking-wide" data-id="element-84">
                      Organization
                    </label>
                    <input type="text" id="organization" name="organization" value={formState.organization} onChange={handleChange} required className="w-full px-4 py-3 border border-[#D4C88A] rounded-sm focus:ring-2 focus:ring-[#C4A44A] focus:border-[#C4A44A] bg-[#FAF9F5]" placeholder="Your Company" data-id="element-85" />
                  </div>
                  <div data-id="element-86">
                    <label htmlFor="message" className="block text-sm font-bold text-[#1E1D14] mb-2 uppercase tracking-wide" data-id="element-87">
                      Message
                    </label>
                    <textarea id="message" name="message" value={formState.message} onChange={handleChange} required rows={4} className="w-full px-4 py-3 border border-[#D4C88A] rounded-sm focus:ring-2 focus:ring-[#C4A44A] focus:border-[#C4A44A] bg-[#FAF9F5]" placeholder="Tell us about your gTLD plans or questions..." data-id="element-88"></textarea>
                  </div>
                  <button type="submit" className="w-full bg-[#C4A44A] text-white py-4 px-6 rounded-sm hover:bg-[#B39540] transition-colors font-bold uppercase tracking-wider shadow-md" data-id="element-89">
                    Send Message
                  </button>
                  <p className="text-xs text-[#5A5535] text-center mt-4" data-id="element-90">
                    By submitting this form, you agree to our{' '}
                    <a href="https://www.gtlaw.com/en/general/footer/terms-of-use" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#C4A44A] transition-colors" data-id="element-91">
                      Terms of Use
                    </a>
                    .
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
};